import BigNumber from "bignumber.js";
import { WalletProvicer } from "./WalletProvider";
import { POSClient, use } from "@maticnetwork/maticjs";
import { Web3ClientPlugin } from "@maticnetwork/maticjs-ethers";
import * as bip39 from "bip39"
import * as util from 'ethereumjs-util'
import { hdkey } from "ethereumjs-wallet"
import { Token, WalletInfo } from "../WalletService";
import { CoinType } from "../../conf/Config";
import DataCenter, { Calculator, QuoteCoinID } from "../DataCenter";
import Web3 from 'web3';
import { Events, JSEvent } from "../../utils/JSEvent";
import MetaVirusNFT from "../MetaVirusNft";
import { Alchemy, AlchemySubscription, Utils, Wallet as AWallet } from "alchemy-sdk";

//const HDWalletProvider = require('@truffle/hdwallet-provider')

// const maticTokenAddress = "0x0000000000000000000000000000000000001010";

export class MATICWalletProvider extends WalletProvicer {
    // #posClient = null;
    #walletInfo = null;
    #web3 = null;
    // #matic = null;
    constructor(blockchain) {
        super(blockchain);

        //this.#web3 = new Web3(new Web3.providers.HttpProvider(blockchain.rpc.url));
        const web3 = new Web3(new Web3.providers.WebsocketProvider(blockchain.rpc.websocket))
        this.#web3 = web3;

        // use(Web3ClientPlugin);
        // this.#posClient = new POSClient();
        // this.posClient.init({
        //     log: true,
        //     network: blockchain.url,
        //     version: 'mumbai',
        //     child: {
        //         provider: new HDWalletProvider(),
        //         defaultConfig: {

        //         }
        //     }
        // });
        //new Web3(new Web3.providers.WebsocketProvider(blockchain.url));
        this.subscribes = [];
    }

    getWeb3() {
        return this.#web3;
    }

    onWalletLoaded(walletInfo) {
        this.#walletInfo = walletInfo;
        return new Promise((resolve, reject) => {
            resolve(this);
        })

        // return new Promise(async (resolve, reject) => {
        //     await this.#posClient.init({
        //         log: true,
        //         network: this.blockchain.url,
        //         version: this.blockchain.version,
        //         child: {
        //             //provider: new HDWalletProvider([walletInfo.privateKey], this.blockchain.rpc.child_url),
        //             provider: new Wallet(walletInfo.privateKey, new providers.JsonRpcProvider(this.blockchain.rpc.child_url)),
        //             defaultConfig: {
        //                 from: walletInfo.address
        //             }
        //         },
        //         parent: {
        //             provider: new Wallet(walletInfo.privateKey, new providers.JsonRpcProvider(this.blockchain.rpc.parent_url)),
        //             defaultConfig: {
        //                 from: walletInfo.address
        //             }
        //         },
        //     })

        //     this.#matic = this.#posClient.erc20("0x0000000000000000000000000000000000001010");
        //     resolve(this);
        //     DataCenter.getCoins().forEach(async coin => {
        //         if (coin.id == CoinType.Matic)
        //             return;
        //         // const associate = await getAssociatedTokenAddress(new PublicKey(coin.address), this.#owner.publicKey);
        //         // this.#connection.onAccountChange(associate, (accountInfo, context) => {
        //         //     JSEvent.emit(Events.Wallet.WalletAccountChanged, coin);
        //         // })
        //     })
        // })
    }

    /**
     * @param {Token} token 
     * @returns {Promise<BigNumber>}
     */
    balanceOf(token, address) {
        return new Promise(async (resolve, reject) => {
            if (this.#web3 == null) {
                reject(this.makeError("web3 is null"))
            } else {
                if (token.name == "Matic") {
                    // this.#ethBalance(address, r => {
                    //     const v = Calculator.toNumber(r, token.id)
                    //     resolve(v);
                    // }, err => {
                    //     reject(err);
                    // })

                    // if (this.#matic != null) {
                    //     const r = await this.#matic.getBalance(address);
                    //     const v = Calculator.toNumber(r, token.id);
                    //     resolve(v);
                    // }

                    this.alchemy.core.getBalance(address).then((r) => {
                        const v = Calculator.toNumber(r.toString(), token.id)
                        resolve(v);
                    }).catch(e => {
                        reject(e);
                    })

                    // this.#ethBalance(address, r => {
                    //     const v = Calculator.toNumber(r, token.id)
                    //     resolve(v);
                    // }, err => {
                    //     reject(err);
                    // })
                } else {
                    console.log("get token balance:", address, token.address)
                    this.alchemy.core.getTokenBalances(address, [token.address]).then((r) => {
                        console.log(token.address, "==>", r);
                        const balance = r.tokenBalances.length > 0 ? r.tokenBalances[0].tokenBalance.toString() : "0";
                        const v = Calculator.toNumber(balance, token.id)
                        console.log("get token balance:", address, token.address, v.toFixed(0))
                        resolve(v);
                    }).catch(e => {
                        console.log("get token balance:", address, token.address, e)
                        reject(e);
                    })

                    // this.#tokenBalance(address, token, r => {
                    //     const v = Calculator.toNumber(r, token.id)
                    //     resolve(v);
                    // }, err => {
                    //     reject(err);
                    // })
                }
                // if (token.name == "SOL") {
                //     const balance = await this.#connection.getBalance(this.#owner.publicKey);
                //     const v = Calculator.toNumber(balance, token.id);
                //     resolve(v);
                // } else {
                //     const associate = await getAssociatedTokenAddress(new PublicKey(token.address), this.#owner.publicKey);
                //     try {
                //         const info = await getAccount(this.#connection, associate);
                //         const v = Calculator.toNumber(info.amount, token.id)
                //         resolve(v);
                //     } catch (e) {
                //         console.warn("token account not found for " + this.#owner.address())
                //         resolve(new BigNumber(0));
                //     }
                // }
            }
        })
    }

    #ethBalance(address, resolve, reject) {
        this.#web3.eth.getBalance(address).then(ret => {
            resolve(ret);
        })
    }

    #tokenBalance(address, token, resolve, reject) {
        const contract = this.contract(token);
        contract.methods.balanceOf(address).call({}, (error, result) => {
            if (error != null) {
                reject(error);
            } else {
                resolve(result);
            }
        })
    }

    importPrivateKey(pk) {
        let privateKey = pk;
        if (!privateKey.startsWith('0x')) {
            privateKey = "0x" + privateKey;
        }
        const ret = this.#web3.eth.accounts.privateKeyToAccount(privateKey);
        const pkBuf = Buffer(privateKey.slice(2), 'hex');
        const publicKey = util.bufferToHex(util.privateToPublic(pkBuf));
        const address = ret.address;

        const wi = new WalletInfo();
        wi.mnemonic = "";
        wi.privateKey = privateKey;
        wi.publicKey = publicKey;
        wi.address = address;
        return wi;
    }

    importMnemonic(mnemonic) {
        return new Promise((resolve, reject) => {
            bip39.mnemonicToSeed(mnemonic).then(v => {
                if (!bip39.validateMnemonic(mnemonic)) {
                    reject({ code: -1, msg: "mnemonic format error" })
                    return;
                }

                const hdWallet = hdkey.fromMasterSeed(v);
                const key = hdWallet.derivePath("m/44'/60'/0'/0/0");
                const privateKey = util.bufferToHex(key._hdkey.privateKey);
                const publicKey = util.bufferToHex(key._hdkey.publicKey);
                let address = util.pubToAddress(key._hdkey.publicKey, true)
                address = util.toChecksumAddress("0x" + address.toString('hex'));


                const wi = new WalletInfo();
                wi.mnemonic = mnemonic;
                wi.privateKey = privateKey;
                wi.publicKey = publicKey;
                wi.address = address;

                resolve(wi);
            });
        })
    }

    isValidAddress(address) {
        return util.isValidAddress(address);
    }

    calcGasFee(gasPrice, gasUsed, quoteCoin) {
        const p = gasPrice.times(gasUsed);
        const p1 = Calculator.toNumber(p, QuoteCoinID);
        const p2 = p1.toTrimed(2, quoteCoin.showDecimals);
        return { bn: p1, str: p2 }
    }

    subscribe() {
        const walletInfo = this.#walletInfo;
        this.alchemy.ws.on(
            {
                method: AlchemySubscription.PENDING_TRANSACTIONS,
                toAddress: walletInfo.address,
            },
            tx => {
                console.log("alchemy event PENDING_TRANSACTIONS:", tx);
                const token = DataCenter.getCoin(CoinType.Matic);
                JSEvent.emit(Events.Wallet.PenddingTransaction, { token: token, trans: tx });
            }
        )
        this.alchemy.ws.on(
            {
                method: AlchemySubscription.MINED_TRANSACTIONS,
                addresses: [{
                    to: walletInfo.address
                }],
            },
            tx => {
                console.log("alchemy event MINED_TRANSACTIONS:", tx);
                const token = DataCenter.getCoin(CoinType.Matic);
                JSEvent.emit(Events.Wallet.Transaction, { token: token, trans: tx });
            }
        )

        // if (this.subscribes.length > 0) {
        //     this.#web3.eth.clearSubscriptions();
        // }
        // this.subscribes = [];

        // const walletInfo = this.#walletInfo;
        // const web3 = WalletService.web3;

        //const topic = this.#web3.eth.abi.encodeEventSignature('Transfer(address from, address to, uint256 value)');
        // const topic = this.#web3.eth.abi.encodeEventSignature({
        //     name: 'Transfer',
        //     type: 'event',
        //     inputs: [{
        //         type: 'address',
        //         name: 'from'
        //     }, {
        //         type: 'address',
        //         name: 'to'
        //     }, {
        //         type: 'uint256',
        //         name: 'value'
        //     }]
        // });

        // DataCenter.getCoins().forEach(token => {
        //     switch (token.id) {
        //         case CoinType.Matic:
        //             const sub = this.#web3.eth.subscribe(
        //                 'pendingTransactions', (error, result) => {
        //                     if (error != null) {
        //                         console.log(error)
        //                     }
        //                 }
        //             ).on('data', t => {
        //                 this.#web3.eth.getTransaction(t).then(t => {
        //                     if (t == null || t.from == null || t.to == null) {
        //                         return;
        //                     }
        //                     const from = util.Address.fromString(t.from);
        //                     const to = util.Address.fromString(t.to);
        //                     const w = util.Address.fromString(walletInfo.address);

        //                     if (from.equals(w) || to.equals(w)) {
        //                         JSEvent.emit(Events.Wallet.Transaction, { token: token, trans: t });
        //                     }
        //                 })
        //             })
        //             this.subscribes.push(sub)
        //             break;
        //         default:
        //             const tsub = this.#web3.eth.subscribe("logs", {
        //                 address: token.address,
        //                 topics: [topic]
        //             }, (error, result) => {
        //                 if (error != null) {
        //                     console.log(error)
        //                 }
        //             }).on('data', (log) => {
        //                 const hf = util.addHexPrefix(new BigNumber(log.topics[1]).toString(16));
        //                 const ht = util.addHexPrefix(new BigNumber(log.topics[2]).toString(16));
        //                 const from = util.Address.fromString(hf);
        //                 const to = util.Address.fromString(ht);
        //                 const w = util.Address.fromString(walletInfo.address);
        //                 if (from.equals(w) || to.equals(w)) {
        //                     const tx = log.transactionHash;
        //                     this.#web3.eth.getTransaction(tx).then(t => {
        //                         JSEvent.emit(Events.Wallet.Transaction, { token: token, trans: t });
        //                     })
        //                 }
        //             }).on('connected', id => {
        //             })
        //             this.subscribes.push(tsub)
        //             break;
        //     }
        // })
    }

    async transfer(walletTxInfo) {
        const to = walletTxInfo.txTo;
        const amount = walletTxInfo.coinType == CoinType.Matic ?
            walletTxInfo.amount - walletTxInfo.gasPrice : walletTxInfo.amount;
        const token = DataCenter.getCoin(walletTxInfo.coinType);

        let trans = null;
        let result = null;

        /**
         * @type {Web3}
         */
        const web3 = this.#web3;
        web3.eth.accounts.wallet.add(this.#walletInfo.privateKey);


        if (token.id == CoinType.Matic) {
            web3.eth.sendTransaction({
                from: walletTxInfo.txFrom,
                to: walletTxInfo.txTo,
                value: amount,
                gas: walletTxInfo.gasUsed,
            }).then(r => {
                console.log(r);
                walletTxInfo.transactionHash = r.transactionHash;
                JSEvent.emit(Events.Wallet.Transaction, { token: token, trans: trans, walletTxInfo: walletTxInfo });
            }).catch(e => {
                console.error(e);
            })

            JSEvent.emit(Events.Wallet.PenddingTransaction, { token: token, walletTxInfo: walletTxInfo })
        } else {
            const encodeAbi = web3.eth.abi.encodeFunctionCall({
                type: "function",
                name: "transfer",
                inputs: [{
                    type: 'address',
                    name: 'to'
                }, {
                    type: 'uint256',
                    name: 'value'
                }]
            }, [
                walletTxInfo.txTo,
                amount
            ])
            const gasPrice = await web3.eth.getGasPrice();
            const nonce = await web3.eth.getTransactionCount(walletTxInfo.txFrom);
            console.log(encodeAbi, gasPrice, nonce);

            const abi = [{
                'constant': "false",
                'type': "function",
                'name': "transfer",
                'inputs': [{
                    'type': 'address',
                    'name': 'to'
                }, {
                    'type': 'uint256',
                    'name': 'value'
                }],
                'outputs': [{
                    "name": "",
                    "type": "bool"
                }]
            }]
            const c = new web3.eth.Contract(abi, token.address);
            const data = c.methods.transfer(walletTxInfo.txTo, amount).encodeABI();
            console.log("===", c, data);



            let txObj = {
                gas: 0,
                gasPrice: new BigNumber(gasPrice).multipliedBy(1.5).toFixed(0),
                to: token.address,
                value: "0",
                data: data,
                from: walletTxInfo.txFrom,
                nonce: nonce
            }

            const g = await web3.eth.estimateGas(txObj);
            console.log(g);
            txObj.gas = Math.floor(g * 1.2);
            const tx = await web3.eth.accounts.signTransaction(txObj, this.#walletInfo.privateKey, (error, tx) => {

            })
            console.log("signTransaction:", tx);
            walletTxInfo.transactionHash = tx.transactionHash;
            web3.eth.sendSignedTransaction(tx.rawTransaction).then(r => {
                console.log("sendSignedTransaction:", r);
                walletTxInfo.transactionHash = r.transactionHash;
                JSEvent.emit(Events.Wallet.Transaction, { token: token, trans: trans, walletTxInfo: walletTxInfo });
            });
            JSEvent.emit(Events.Wallet.PenddingTransaction, { token: token, walletTxInfo: walletTxInfo })


            // let transaction = {
            //     to: token.address,
            //     value: "0",
            //     maxPriorityFeePerGas: gasPrice,
            //     gas: 31000,
            //     nonce: nonce,
            //     type: 2,
            //     chainId: DataCenter.blockchain().chainId,
            //     data: encodeAbi,
            // };
            // const rawTx = await new AWallet(this.#walletInfo.privateKey).signTransaction(transaction);
            // //const tx = await this.alchemy.core.sendTransaction(rawTx);
            // web3.eth.sendSignedTransaction(rawTx).on('transactionHash', function (txHash) {
            //     console.log(txHash);
            // }).on('receipt', function (receipt) {
            //     console.log("receipt:" + receipt);
            // }).on('confirmation', function (confirmationNumber, receipt) {
            //     console.log("confirmationNumber:" + confirmationNumber + " receipt:" + receipt);
            // }).on('error', function (error) {
            //     console.log(error);
            // });
        }

        // const nonce = await web3.eth.getTransactionCount(walletTxInfo.txFrom);

        // var rawTx = {
        //     from: walletTxInfo.txFrom,
        //     nonce: nonce,
        //     gasPrice: web3.utils.toHex(8000000),
        //     gasLimit: web3.utils.toHex(30000),
        //     to: walletTxInfo.txTo,
        //     value: web3.utils.toHex(amount),
        //     data: '',
        //     accessList: [
        //         {
        //             address: '0x0000000000000000000000000000000000001010',
        //         }
        //     ]
        // }

        // const common = Common.custom(CustomChain.PolygonMumbai);

        // const tx = Transaction.fromTxData(rawTx, { common });
        // const pKey = Buffer.from(this.#walletInfo.privateKey.slice(2), "hex");

        // tx.sign(pKey);

        // var serializedTx = '0x' + tx.serialize().toString("hex");

        // web3.eth.sendSignedTransaction(serializedTx, (err, hash) => {
        //     console.log(err, hash);
        // })



        // if (token.id == CoinType.Matic) {
        //     const matic = this.#posClient.erc20(maticTokenAddress);
        //     //const v = await matic.getBalance(walletTxInfo.txFrom);
        //     result = await matic.transfer(amount, to, { gasPrice: '30000000000' });
        // } else {
        // }

        // walletTxInfo.transactionHash = await result.getTransactionHash();

        // console.log("Polygon Tx: ", walletTxInfo.transactionHash);

        // JSEvent.emit(Events.Wallet.PenddingTransaction, { token: token, walletTxInfo: walletTxInfo })

        // const receipt = await result.getReceipt();

        // JSEvent.emit(Events.Wallet.Transaction, { token: token, trans: trans, walletTxInfo: walletTxInfo });

        // //const sign = await sendAndConfirmTransaction(this.#connection, trans, [this.#owner]);
        // return walletTxInfo.transactionHash;
    }


    /**
     * 返回对应区块链网络的浏览地址
     * @param {"tx"|"address"} item 
     * @param {string} value 
     */
    getExplorer(item, value) {
        console.log(item, value);
        return {
            name: "PolygonScan",
            url: `https://www.polygonscan.com/${item}/${value}`
        };
    }
}